import React from 'react';

import UploadOrChooseFromMediaLibraryModal
  from 'zoomforth_codesbane_editor/component_lib/upload_or_choose_from_media_library_modal.jsx';

const ConfirmCreatePdfModal = ({
  show,
  shouldShowMediaLibrarySelectionOption,
  onRequestClose,
  onUploadClick,
  onSelectFromMediaLibraryClick
})=> (
  <UploadOrChooseFromMediaLibraryModal
    show={show} 
    shouldShowMediaLibrarySelectionOption={shouldShowMediaLibrarySelectionOption}
    title="Add PDF Embed"
    uploadFileText="Upload PDF file"
    selectFromMediaLibraryText="Add PDF from Media Library"
    onRequestClose={onRequestClose}
    onSelectFromMediaLibraryClick={onSelectFromMediaLibraryClick}
    onUploadClick={onUploadClick}
  />
);

export default ConfirmCreatePdfModal;
